import React, { ComponentState, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getClientQuestionnaires, getPendingDoc, getSignedDoc, saveSignedDocResponse } from "../../../../../redux/actions"
import { MetaData, QuestionnaireRequestObj, ResultDocumentData } from "../../../../../dataModel/documentModels"
import moment from "moment"
import { DocumentListComponent } from "./documentListComponent"
import { QuestionnaireListComponent } from "./questionnaireListComponent"

export const CompletedquestionnairesList = () => {

  const state: ComponentState = useSelector(states => {
    return states;
  });

  const { completedQuestionnaires } = state['ClientReducer'];
  const { loadingState } = state['LoaderReducer'];


  var now = moment(new Date()).format("YYYY-MM-DD");
  var previous = moment(new Date()).subtract(5, 'years').format("YYYY-MM-DD");
  const emptyObj: QuestionnaireRequestObj = { isCompleted: true, pageNumber: 1, pageSize: 10 }
  const [requestObj, setRequestObj] = useState<QuestionnaireRequestObj>(emptyObj)
  const [signedDocList, setSignedDocList] = useState()
  const [metaObj, setMetaObj] = useState<MetaData>()
  const dispatch = useDispatch()
  const [isDataFetched, setIsDataFetched] = useState(false)

  useEffect(() => {
    if (!isDataFetched) {
      setIsDataFetched(true)
      dispatch(getClientQuestionnaires(requestObj))
    }
  }, [isDataFetched])

  useEffect(() => {
    if(completedQuestionnaires) {
        setSignedDocList(completedQuestionnaires?.resultData)
        setMetaObj(completedQuestionnaires?.metaData)
    }
  }, [completedQuestionnaires])

  function handleChangePage (event: any, newPage: any) {
    setRequestObj({ ...requestObj, pageNumber: (newPage + 1) })
    dispatch(getClientQuestionnaires({ ...requestObj, pageNumber: (newPage + 1) }))
  }

   function handleChangeRowsPerPage(event: any) {
    setRequestObj({ ...requestObj, pageSize: parseInt(event.target.value, 10), pageNumber: 1 })
    dispatch(getClientQuestionnaires({ ...requestObj, pageSize: parseInt(event.target.value, 10), pageNumber: 1 }))
   }


  

  return (  <QuestionnaireListComponent
    tabSelecteionID="tabs-4"
    loadingState={loadingState}
    tabId={4}
    documentList={signedDocList? signedDocList:[]}
    handleChangePage={handleChangePage}
    handleChangeRowsPerPage={handleChangeRowsPerPage}
    metaObj={metaObj}
    requestObj={requestObj}
    ></QuestionnaireListComponent>);
}